import React from 'react';
import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import CommentIcon from '@atlaskit/icon/core/comment';
import LikeIcon from '@atlaskit/icon/core/thumbs-up';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

import { i18n } from '../contentReportTableMacroI18n.ts';

const styles = cssMap({
	socialItem: {
		color: token('color.text.subtle'),
	},
	count: {
		font: token('font.body.small'),
	},
});

interface SocialCellProps {
	commentCount: number;
	likeCount: number;
	showCommentsCount: boolean;
	showLikesCount: boolean;
}

export const SocialCell = ({
	commentCount,
	likeCount,
	showCommentsCount,
	showLikesCount,
}: SocialCellProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.100" alignBlock="center">
			{showCommentsCount && commentCount > 0 && (
				<Inline space="space.050" alignBlock="center" xcss={styles.socialItem}>
					<CommentIcon label={formatMessage(i18n.comments, { count: commentCount })} size="small" />
					<Box as="span" xcss={styles.count}>
						{commentCount}
					</Box>
				</Inline>
			)}
			{showLikesCount && likeCount > 0 && (
				<Inline space="space.050" alignBlock="center" xcss={styles.socialItem}>
					<LikeIcon label={formatMessage(i18n.likes, { count: likeCount })} size="small" />
					<Box as="span" xcss={styles.count}>
						{likeCount}
					</Box>
				</Inline>
			)}
		</Inline>
	);
};
